export function encodeRequestBody(body: string): string {
  return Buffer.from(body).toString('base64')
}
